import React from 'react'
import gif from '../assets/gifmaker_me (1).gif'

const CardImg = () => {
  return (
    <div>
        <div className="mt-10 mb-0 md:mt-0">
          <img src={gif} alt="nerve" className='md:w-[80%] lg:w-[580px] lg:h-[600px] lg:p-3 object-cover'/>
        </div>
    </div>
  )
}

export default CardImg